import { Eye, EyeClosed } from "lucide-react";
import { useState } from "react";
import styles from './PasswordToggleInput.module.scss';

export function PasswordToggleInput({
  name,
  label,
  placeholder,
  register,
  rules,
  error,
  disabled,
  customClass,
  ...rest
}: any) {
  const [show, setShow] = useState(false);

  return (
    <div className={styles.inputContainer}>
      {label && <label htmlFor={name}>{label}</label>}

      <div  className={styles.inputWithIcon}>
        <input
          {...(register ? register(name, rules) : {})}
          {...rest}
          type={show ? "text" : "password"}
          name={name}
          id={name}
          placeholder={placeholder}
          disabled={disabled}
          className={styles.inputs}
        />

        <button
          type="button"
          className={styles.iconButton}
          onClick={() => setShow((v) => !v)}
          aria-label={show ? "Ocultar senha" : "Mostrar senha"}
        >
          {show ? <Eye size={18} /> : <EyeClosed size={18} />}
        </button>
      </div>

      {error && <p className={styles.error}>{error}</p>}
    </div>
  );
}
